const display = {
    namespaced: true,
    state: {
        displayList: [],
        selectedDisplay: {},
    },
    mutations: {
        updateDisplayList(state, newList) {
            state.displayList = newList;
        },
        setSelectedDisplay(state, display) {
            state.selectedDisplay = display;
        }
    },
    actions: {
        getDisplayList(context) {
            this._vm.$traveller_http.get('/traveller/restui/display/listDisplays')
                .then(function(response) {
                    context.commit('updateDisplayList', response.data);
            })
        },
        getDisplaySettings(context, displayId) {
            return new Promise((resolve , reject) => {
                //console.log("getDisplay settings " + displayId )
                this._vm.$traveller_http.get('/traveller/restui/display/getDisplaySettings' , { params: { "displayId": displayId } } )
                   .then( response => {                
                        resolve(response)
                }), error => {
                    reject(error)
                }
            })   
        },
        saveDisplay(context , displayItem ) {
            return new Promise((resolve , reject ) => {
                this._vm.$traveller_http.post('/traveller/restui/display/setDisplay' , displayItem  )
                .then( response => {
                    if( response.status == 200 )
                        resolve(response)
                    else
                        reject()
                }), error => {
                    reject(error)
                }
            })
        },
        deleteDisplay(context , displayId ) {
            return new Promise((resolve , reject ) => {
                this._vm.$traveller_http.get('/traveller/restui/display/deleteDisplay' , { params: { "displayId" : displayId }} )
                .then( response => {
                    resolve(response)
                }), error => {  
                    reject(error)
                }
            })
        }
    }, 
    getters: {
        getDisplayById: (state) => (id) => {
            return state.displayList.find( display => display.id === id);
        }
    }
}

export default display;